import _objectSpread from "/var/jenkins_home/workspace/front-flashhr-backyard-ms@2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import '../../../directive.js';
export default {
  props: {
    // 表格是否有操作列
    edit: {
      type: Boolean,
      default: true
    },
    tableData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    tableCloumn: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    info: {
      type: Object,
      default: function _default() {}
    }
  },
  title: 'all-info',
  data: function data() {
    return {
      cTableData: this.tableData,
      detailExplail: {
        tax_deduction_7: 'payroll_deduction_all_01',
        tax_deduction_8: 'payroll_deduction_all_02',
        tax_deduction_9: 'payroll_deduction_all_03',
        tax_deduction_10: 'payroll_deduction_all_04',
        tax_deduction_11: 'payroll_deduction_all_05',
        tax_deduction_12: 'payroll_deduction_all_06',
        tax_deduction_13: 'payroll_deduction_all_07',
        tax_deduction_14: 'payroll_deduction_all_08',
        tax_deduction_15: 'payroll_deduction_all_09',
        tax_deduction_16: 'payroll_deduction_all_10',
        tax_deduction_all: 'payroll_deduction_all_0',
        tax_deduction_17: '23786_58b73929',
        tax_deduction_18: '23786_2aa87553',
        tax_deduction_19: '23786_aa87553f',
        tax_deduction_20: '23786_a87553f7',
        tax_deduction_21: '23786_87553f7f',
        tax_deduction_22: '23786_7553f7f2',
        tax_deduction_23: '23786_d943cb9d'
      }
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState({
    contentViewHeight: function contentViewHeight(state) {
      return state.settings.contentViewHeight;
    }
  })), {}, {
    tableHeight: function tableHeight() {
      return 500;
    }
  }),
  watch: {
    tableCloumn: function tableCloumn(val) {
      var _this = this;
      this.$nextTick(function () {
        _this.$refs.table.doLayout();
      });
    },
    tableData: function tableData(val) {
      this.cTableData = val;
    }
  },
  methods: {
    // 排序
    handlerSort: function handlerSort(params) {
      this.$emit('sort', params);
    },
    selectValue: function selectValue(arr, value) {
      var a = arr.filter(function (i) {
        return i.value === value;
      });
      return a[0] && (a[0].label || a[0].value) || '';
    },
    handleClick: function handleClick(row, status, scope, save) {
      this.$emit('handleEdit', row, status, scope, save);
    }
  }
};